import React from "react";
import {  Grid  } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { FormTitle } from "@commonComponents/FormTitle";
import { useSelector } from "react-redux";


export const WareHouseDetailForm=React.memo(({className='',wareHouseBoxNo="5/9",dataSource={},onChange,onBlur,onSelect})=>{
 const warehouseTypeList=useSelector(state=>state.dropDownReducer.warehouseType)
 return (
  <div className={`${className} col formContainer`}>
        <FormTitle className="formTitle" textAlign="start" title="WAREHOUSE_DETAILS"  />
    <Grid.Row>
    <Grid.Column>
  
      <InputField
        id="wareHouseId"
        name="id"
        boxNumber={wareHouseBoxNo}
        type="text"
        clearInput={false}
        label="WAREHOUSE_ID"
        onChange={onChange}
        onBlur={onBlur}
        value={dataSource.id || ""}
      />
    </Grid.Column>
   
    <Grid.Column>
    <DropDown
                id="warehouseType"
                label="WAREHOUSE_TYPE"
                clearable
                name="type"
                labelClass="text-none"
                data={warehouseTypeList}
                value={dataSource.type}
                text={dataSource.type}
                onChange={onSelect}
        />
    
    </Grid.Column>
    
  </Grid.Row>
  </div>
  )
})
WareHouseDetailForm.defaultProps = {
  translate:(value)=>value
}